<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="auto-qa-groups-teams-page" element-loading-text="Loading...">
    <div v-if="showGroupsTeamsPage">
      <div class="button-flex">
        <div class="auto-qa-groups-teams-page-title">Evaluation</div>
      </div>
      <div class="wy-page-tab">
        <el-tabs ref="tabs" v-model="activeTab" @tab-click="handleTabClick" :before-leave="beforeLeave">
          <el-tab-pane label="Groups" name="groups" :disabled="disableTab">
            <wy-auto-qa-evaluation-groups-tab ref="groups" :parent="module" :activeTab="activeTab" />
          </el-tab-pane>
          <el-tab-pane label="Teams" name="teams" :disabled="disableTab" style="padding: 25px;">
            <wy-auto-qa-evaluation-teams-tab ref="teams" :parent="module" :activeTab="activeTab" />
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- <div>
        <wy-home-auto-qa-panel-performance-gauge-summary ref="gaugeSummary" :controller="module" v-loading="loading" />
        <wy-auto-qa-panel-dynamic-chart ref="dynamicChart" :controller="module" :selectedGaugePanel="selectedGaugePanel" />
      </div> -->

      <!-- <wy-home-auto-qa-panel-table-summary ref="tableSummary" :tableData="tableData" :controller="module" v-loading="loading || tableLoading" /> -->

    </div>
    <div v-else>
      <!-- <page-no-data title="Home" /> -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';

import WyAutoQAEvaluationGroupsTab from './wy-auto-qa-evaluation-groups-tab.vue';
import WyAutoQAEvaluationTeamsTab from './wy-auto-qa-evaluation-teams-tab.vue';

  export default Vue.extend({
    name: 'wy-auto-qa-groups-teams-page',
    components: {
      'wy-auto-qa-evaluation-groups-tab': WyAutoQAEvaluationGroupsTab,
      'wy-auto-qa-evaluation-teams-tab': WyAutoQAEvaluationTeamsTab,    },
    props: ['groupId', 'teamId'],
    data() {
      return {
        module: this,
        activeTab: 'groups',
        loading: false,
        tabChanged: false,
        showGroupsTeamsPage: true,
        cloneFilters: null,
        // dynamicChartsLoading: false,
        noGroups: false,
        noTeams: false,
        groups: [],
        teams: [],
        agents: [],
        groupsTeamsLineChartLoading: false,
        groupsTeamsBarChartLoading: false,
        groupsTeamsTableLoading: false,
      }
    },

    computed: {
      ...mapGetters(['dataModel', 'tableModel', 'filterChangedStatus']),

      disableTab() { 
        return this.groupsTeamsLineChartLoading || this.groupsTeamsBarChartLoading || this.groupsTeamsTableLoading
      },

      isFilterChanged() {
        return JSON.stringify(this.cloneFilters) !== JSON.stringify(this.dataModel.filters)
      },
    },

    methods: {
      ...mapMutations(["updateTableModelResult", "updateDataModelColumns"]),
      ...mapActions(['fetchAutoQAEvalGroupTeamLineChart', 'fetchAutoQAEvalGroupTeamBarChart', 'fetchAutoQAEvalPageFilters']),

      async handleTabClick() {
        if(this.tabChanged && !this.disableTab) {
          if(this.$refs[this.activeTab].fetchData) {
            this.$refs[this.activeTab].noData = false;
            await this.handlePanelChange();
          }
          else if(!this.$refs[this.activeTab].tableLoading){
            this.$refs[this.activeTab].tableLoading = true;
            setTimeout(() => {
              if(this.$refs[this.activeTab].tableData) {
                this.updateTableModelResult(this.$refs[this.activeTab].tableData)
                this.updateDataModelColumns({ columns: this.$refs[this.activeTab].columns });
              }
              this.$refs[this.activeTab].$refs.table && this.$refs[this.activeTab].$refs.table.refreshTable({ disablePageLoading: true });
              this.$refs[this.activeTab].tableLoading = false;
            }, 50);
          }
          this.tabChanged = false;
        }
      },

      resetFetchDataStatus() {
        if (this.$refs.groups) {
          this.$refs.groups.fetchData = true;
          if(this.$refs.groups.$refs.dynamicChart) this.$refs.groups.$refs.dynamicChart.selectedDateRange = null;
        }
        if (this.$refs.teams) {
          this.$refs.teams.fetchData = true;
          if(this.$refs.teams.$refs.dynamicChart) this.$refs.teams.$refs.dynamicChart.selectedDateRange = null;
        } 
      },

      async handleFilterChange(firstTime) {
        this.resetFetchDataStatus();
        this.loading = true
        const res = await this.fetchAutoQAEvalPageFilters()
        this.noGroups = (res.data.agentGroups.length > 0) ? false : true
        this.noTeams = (res.data.agentTeams.length > 0) ? false : true
        let groups = [];
        groups.push({
          key:'all',
          label: 'All'
        })
        res.data.agentGroups.forEach(group => {
          let obj = {}
          obj.key = group.groupId
          obj.label =  group.groupName
          groups.push(obj)
        })
        this.groups = groups;
        
        let teams = [];
        teams.push({
          key:'all',
          label: 'All'
        })
        res.data.agentTeams.forEach(team => {
          let obj = {}
          obj.key = team.teamId
          obj.label =  team.teamName
          teams.push(obj)
        })
        
        this.teams = teams;
        this.loading = false
        if(!firstTime && this.isFilterChanged) {
          this.$refs.groups.selectedGroup = 'all'
          this.$refs.teams.selectedTeam = 'all'
        }
        await this.handlePanelChange();
        this.cloneFilters = JSON.parse(JSON.stringify(this.dataModel.filters))
      },

      beforeLeave() {
        // this.$refs[this.activeTab].tableLoading = false;
        // this.$refs[this.activeTab].dynamicChartsLoading = false;
        this.tabChanged = true;
      },

      checkExistSelectedItem(list, selectedItem) {
        let noData = true;
        if(list.length > 1) {
          list.forEach(item => {
            if(selectedItem === 'all' || selectedItem === item.key) {
              noData = false;
            }
          })
        }
        return !noData;
      },

      mappingGroupName(groupId) {
        let groupName = groupId
        this.groups.forEach(group => {
          if(group.key == groupId) {
            groupName = group.label
          }
        })
        return groupName
      },

      mappingTeamName(TeamId) {
        let teamName = TeamId
        this.teams.forEach(team => {
          if(team.key == TeamId) {
            teamName = team.label
          }
        })
        return teamName
      },

      async handlePanelChange() {
        if(this.activeTab === 'groups') {
          this.$refs.groups.showTab = false;
          this.$refs.groups.dynamicChartsLoading = true;
          this.$refs.groups.tableLoading = true;
          this.$refs.groups.noData = false;
          let selectedGroups = [];
          if(this.$refs.groups.selectedGroup == 'all') {
            this.groups.forEach(group => {
              if(group.key !== 'all') {
                selectedGroups.push(group.key)
              }
            })
          }
          else {
            selectedGroups.push(this.$refs.groups.selectedGroup)
          }
          let options = {
            type: 'agentGroups',
            apiType: 'group',
            displayName: this.mappingGroupName(this.$refs.groups.selectedGroup),
            value: selectedGroups
          }
          let hasGroup = this.checkExistSelectedItem(this.groups, this.$refs.groups.selectedGroup)
          if(hasGroup) {
            this.groupsTeamsLineChartLoading = true;
            this.fetchAutoQAEvalGroupTeamLineChart(options).then((results)=>{
              if(results) {
                // setTimeout(() => {
                  this.renderLineChart(results, this.$refs.groups.$refs.dynamicChart)
                  if(this.$refs.groups.$refs.dynamicChart.selectedDateRange) {
                    this.$refs.groups.$refs.dynamicChart.handleLineChartViewBy(this.$refs.groups.$refs.dynamicChart.selectedDateRange, false)
                  }
                  if(this.$refs.groups.selectedGroup === 'all') {
                    this.$refs.groups.lineChartLegends = ['All groups'];
                  }
                  else {
                    this.$refs.groups.lineChartLegends = [options.displayName, 'All groups'];
                  }
                  this.groupsTeamsLineChartLoading = false;
                // }, 50)
              }
            })

            this.groupsTeamsBarChartLoading = true;
            this.fetchAutoQAEvalGroupTeamBarChart(options).then((results)=>{
              if(results) {
                this.renderBarChart(results, this.$refs.groups.$refs.dynamicChart)
                this.groupsTeamsBarChartLoading = false;
              }
            })
            this.$refs.groups.fetchGroupTableSummary()
            
            this.$refs.groups.showTab = true;
            this.$refs.groups.noData = false;
          }
          else {
            this.$refs.groups.noData = true
            this.$refs.groups.showTab = true;
            this.$refs.groups.dynamicChartsLoading = false;
            this.$refs.groups.tableLoading = false;
            return false
          }
        }
        if(this.activeTab === 'teams') {
          this.$refs.teams.showTab = false;
          this.$refs.teams.dynamicChartsLoading = true;
          this.$refs.teams.tableLoading = true;
          this.$refs.teams.noData = false;
          let selectedTeams = [];
          if(this.$refs.teams.selectedTeam == 'all') {
            this.teams.forEach(team => {
              if(team.key !== 'all') {
                selectedTeams.push(team.key)
              }
            })
          }
          else {
            selectedTeams.push(this.$refs.teams.selectedTeam)
          }
          let options = {
            type: 'agentTeams',
            apiType: 'team',
            displayName: this.mappingTeamName(this.$refs.teams.selectedTeam),
            value: selectedTeams
          }
          let hasTeam = this.checkExistSelectedItem(this.teams, this.$refs.teams.selectedTeam)
          if(hasTeam) {
            this.groupsTeamsLineChartLoading = true;
            this.fetchAutoQAEvalGroupTeamLineChart(options).then((results)=>{
              if(results) {
                if(this.$refs.teams.selectedTeam === 'all') {
                  this.$refs.teams.lineChartLegends = ['All teams in group'];
                }
                else {
                  this.$refs.teams.lineChartLegends = [options.displayName, 'All teams in group'];
                }
                this.renderLineChart(results, this.$refs.teams.$refs.dynamicChart)
                if(this.$refs.teams.$refs.dynamicChart.selectedDateRange) {
                  this.$refs.teams.$refs.dynamicChart.handleLineChartViewBy(this.$refs.teams.$refs.dynamicChart.selectedDateRange, false)
                }
                this.groupsTeamsLineChartLoading = false;
              }
            })

            this.groupsTeamsBarChartLoading = true;
            this.fetchAutoQAEvalGroupTeamBarChart(options).then((results)=>{
              if(results) {
                this.renderBarChart(results, this.$refs.teams.$refs.dynamicChart)
                this.groupsTeamsBarChartLoading = false;
              }
            })
            this.$refs.teams.fetchTeamTableSummary();

            this.$refs.teams.showTab = true;
            this.$refs.teams.noData = false;
          }
          else {
            this.$refs.teams.noData = true;
            this.$refs.teams.dynamicChartsLoading = false;
            this.$refs.teams.tableLoading = false;
            return false
          }
        }
      },

      renderLineChart(volumeData, dynamicChartRef) {
        const apiVolumeData = volumeData.autoEvalScore;
        if(dynamicChartRef) {
          if (apiVolumeData) {
            if(!dynamicChartRef.networkData.autoEvalScore) {
              dynamicChartRef.networkData.autoEvalScore = {}
            }
            dynamicChartRef.networkData.autoEvalScore.dailyMetrics = apiVolumeData.dailyMetrics;
            dynamicChartRef.networkData.autoEvalScore.displayName = apiVolumeData.displayName;
            dynamicChartRef.showLineChart = true;
            const noData =
              dynamicChartRef.networkData.autoEvalScore.dailyMetrics.length &&
              dynamicChartRef.networkData.autoEvalScore.dailyMetrics.every((metric) => metric.value == -1);

            if (noData) {
              dynamicChartRef.showLineChart = false;
            }
          }
          else {
            dynamicChartRef.showLineChart = false;
          }
        }
      },

      renderBarChart(barData, dynamicChartRef) {
        if(barData && barData.autoEvalSectionScore && dynamicChartRef) {
          dynamicChartRef.barChartHasData = true;
          const barDataExists = barData && Object.keys(barData) && Object.keys(barData).length;

          if (!barDataExists) {
            dynamicChartRef.barChartHasData = false;
          }

          if(!dynamicChartRef.networkData.autoEvalScore) {
            dynamicChartRef.networkData.autoEvalScore = {}
          }

          dynamicChartRef.networkData.autoEvalScore.barMetrics = {};
          if(Object.keys(barData.autoEvalSectionScore.barMetrics).length > 0) {
            Object.keys(barData.autoEvalSectionScore.barMetrics).forEach((item) => {
              if(barData.autoEvalSectionScore.barMetrics[item] != null && barData.autoEvalSectionScore.barMetrics[item] != '-1') {
                dynamicChartRef.networkData.autoEvalScore.barMetrics[item] = barData.autoEvalSectionScore.barMetrics[item]
              } else {
                // for -1 case, we need to show "N/A" as the bar value, but "hide" the bar
                dynamicChartRef.networkData.autoEvalScore.barMetrics[item] = '0.00001'; // workaround to show N/A
              }
            })
          }
          const noData = Object.values(dynamicChartRef.networkData.autoEvalScore.barMetrics).every((metric) => metric == -1);
          if (noData) dynamicChartRef.barChartHasData = false;
          dynamicChartRef.reloadBothPanels();
          this.handleRenderBarChart(dynamicChartRef, 'autoEvalScore');
        }
      },

      handleRenderBarChart(dynamicChartRef) {
        dynamicChartRef.showBarChart = true;
      },
    },

    async mounted() {
      if(this.teamId) {
        this.$refs.teams.selectedTeam = this.teamId
      }
      else {
        this.$refs.teams.selectedTeam = 'all'
      }
      await this.handleFilterChange(true);
      setTimeout(() => {
        document.getElementById('tab-groups') ? document.getElementById('tab-groups').setAttribute('data-testid', 'AutoQM-Evaluation-GroupsTab') : undefined;
        document.getElementById('tab-teams') ? document.getElementById('tab-teams').setAttribute('data-testid', 'AutoQM-Evaluation-TeamsTab') : undefined;
      }, 10);
    },

    async created() {
      this.$router.currPageComponent = this;
      this.initDate = new Date();
      // listen events from other components
      this.$root.registerPageEvent(this.$route.name, (event) => {
        if (this[event.name]) this[event.name]();
      });
      if(this.teamId) {
        this.activeTab = 'teams';
      }
    },
  })

</script>

<style lang="scss">
  .auto-qa-groups-teams-page {
    .auto-qa-groups-teams-page-title {
      color: var(--site-font-secondary-color);
      font-size: 25px;
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-weight: 600;
      min-width: 430px;
    }

    .wy-page-tab {
      border-radius: 5px;
      padding-top: 10px;
      padding-bottom: 3px;

      .main-section {
        padding-bottom: 20px;

        .wy-table-pagination {
          margin-bottom: 0px;
        }
      }

      .el-tabs__active-bar {
        width: var(--site-tab-item-width);
        background-color: var(--site-tab-item-underline-background-color);
        height: var(--site-tab-item-underline-height);
        padding: 0px;
        left: var(--site-tab-item-underline-left);
        left: 10px;
      }
      .el-tabs__item {
        padding: var(--site-tab-item-padding);
        height: 35px;
        line-height: 26px;
        width: var(--site-tab-item-width) !important;
        box-sizing: content-box;
        text-align: center;
        color: var(--site-tab-item-color);
        font-weight: 400;
        font-size: var(--site-tab-item-font-size);
        border: var(--site-tab-item-border);
        background-color: var(--site-tab-item-background-color);
        margin-right: var(--site-tab-item-margin-right);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding-top: 7px;
      }
      .el-tabs__item:hover {
        color: var(--site-tab-item-hover-color);
      }
      .el-tabs__item.is-top:nth-child(2) {
        padding-left: var(--site-tab-item-padding-nth-child);
        padding-left: 0px;
        margin-left: 10px;
      } 
      
      .el-tabs__item.is-active {
        background-color: var(--site-tab-active-item-background-color);
        color: var(--site-tab-active-item-color);
      }

      .el-tabs__nav-wrap::after {
        height: 1px;
        left: 10px;
        width: calc(100% - 20px);
      }

      #pane-groups, #pane-teams {
        padding: 25px 10px 0px 10px !important;
        .wy-analytics-contact-reasons-detail-metrics {
          min-width: 1393px;
          height: calc(100vh - 270px) !important;
          overflow-y: auto;
        }
      }
      .el-tabs__item.is-disabled {
        cursor: not-allowed;
      }
    }
  }
  
</style>